import { useTelegram } from '@st/telegram/composables/useTelegram'

export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) return undefined
  const { isTgMiniAppInSafari } = useTelegram()
  if (!isTgMiniAppInSafari.value) return undefined
  return navigateTo({
    query: {
      modal: 'webTelegramForbidden',
    },
  })
})
